module.exports = __webpack_public_path__ + "img/KK0039C-GL.1989b1b4.jpg";